import FormattedMessage from 'I18n/components/FormattedMessage';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Header } from 'foundations-components/transitional/components/Header';
import _isNil from 'hs-lodash/isNil';
import _omitBy from 'hs-lodash/omitBy';
import { useContext } from 'react';
import { defaultPlaybooksProps } from '../../../constants/playbooks';
import { objectTypes } from '../../../constants/types';
import { AppContext } from '../../../contexts/app/context';
import FeaturePopupOver from '../../common/FeaturePopupOver';
import PlaybookList from './PlaybookList';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const PlaybookListInModal = ({
  selectedObjectType,
  selectedObjectId,
  portalId,
  apiWrapper,
  openUrl,
  callObjectId,
  usageTracker,
  featureTipsLink,
  reconnectRoute
}) => {
  const {
    features
  } = useContext(AppContext);
  if (selectedObjectType === objectTypes.meetings) return null;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Header, {
      headingLevel: "h5",
      title: "Playbooks",
      flush: true,
      use: "condensed"
    }), features.PLAYBOOKS.available ? /*#__PURE__*/_jsx(PlaybookList, {
      fromModal: true,
      selectedObjectType: selectedObjectType,
      selectedObjectId: selectedObjectId,
      apiWrapper: apiWrapper,
      openUrl: openUrl,
      portalId: portalId,
      callObjectId: callObjectId,
      usageTracker: usageTracker
    }) : /*#__PURE__*/_jsxs(TFlex, {
      align: "center",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "playbooks.featureDisabled"
      }), /*#__PURE__*/_jsx(FeaturePopupOver, {
        portalId: portalId,
        featureDisabledReason: features.PLAYBOOKS.reason,
        openUrl: openUrl,
        featureTipsLink: featureTipsLink,
        reconnectRoute: reconnectRoute
      })]
    })]
  });
};
const WrappedPlaybookListInModal = props => {
  const definedProps = _omitBy(props, _isNil);
  const apiWrapper = _omitBy(props.apiWrapper, _isNil);
  const properties = Object.assign({}, defaultPlaybooksProps, definedProps, {
    apiWrapper: Object.assign({}, defaultPlaybooksProps.apiWrapper, apiWrapper)
  });
  return /*#__PURE__*/_jsx(PlaybookListInModal, Object.assign({}, properties));
};
export default WrappedPlaybookListInModal;